import React from "react";
import { ArrowUpward } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { FixedBtn } from "../FixedBtn/FixedBtn";
import "./ArticlesLayout.scss";
import { Outlet } from "react-router-dom";
import MainHeader from "../Landing/MainHeader";

const ArticlesLayout = () => {
  const { t: _t } = useTranslation();

  return (
    <div className="articlesLayout">
      <FixedBtn
        bottom={{ bottom: 10 }}
        bg={{ background: "#929292" }}
        tooltip={_t("To top")}
        icon={<ArrowUpward />}
        onClick={() => {}}
        toTopBtn
      />
      <MainHeader />
      <Outlet />
    </div>
  );
};

export default ArticlesLayout;
